import React, { Component } from 'react';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import { Grid, Typography, Button, TextField } from '@material-ui/core';
import { MIGHTYMEALS_INDEX_IMG } from '../../constants';
import { useStyles } from './styles.js';
import WMSubmit from './WMSubmit';
import GeneralSubmitView from './GeneralSubmitView.js';
import savePickemAnswer from '../../data/mutations/front/pickem/savePickemAnswer';
import randomizePickemAnswer from '../../data/mutations/front/pickem/randomizePickemAnswer';

class Pickem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitted: false,
      selected: {},
      correct_answer_count: 0,
      question_count: props.questions.length,
      questions_answered: 0,
      total_questions_answered: 0,
      total_questions: 0,
      total_tiebreaker_questions: 0,
      total_answered_tiebreaker_questions: 0,
      answered_tiebreaker_question: false,
      question_answer_count: {},
      tempIndex: 0,
      leftPartOfQuestions: [],
      rightPartOfQuestions: [],
      isOptionSubmitted: false,
      tiebreaker: null,
      tiebreaker_id: null,
      editedTiebreaker: false,
      current_question: 0,
      correct_answer_submitted: 0,
      // Questions in chapter that can be answered at current time (= no correct answer submitted)
      open_questions: [],
    };
    this.submitChapter = this.submitChapter.bind(this);
    this.submittingIndividualChapter = this.submittingIndividualChapter.bind(this);
    this.changeQuestion = this.changeQuestion.bind(this);
  }

  componentDidMount() {
    if (this.props.answers && this.props.answers.length > 0) {
      let selected = {};
      let answered_tiebreaker_question = this.state
        .answered_tiebreaker_question;
      let check = this.checkTieBreakerAdnBuildAnswers(
        selected,
        this.props.answers,
        answered_tiebreaker_question,
      );
      answered_tiebreaker_question = check.answered_tiebreaker_question;
      selected = check.selected;

      this.setState({
        selected: selected,
        questions_answered:
          Object.keys(selected).length - this.state.excludeTieBreakerPoints,
        answered_tiebreaker_question,
      });
    }

    if (this.props.getGuestGameQuestionAnswerCount) {
      let question_answer_count = this.props.getGuestGameQuestionAnswerCount;
      this.setState({
        question_answer_count,
      });
    }

    if (this.props.questions) {
      let temp = 0;
      let correct_answer_submitted = 0;
      let leftPartOfQuestions = [];
      let rightPartOfQuestions = [];
      const questions = this.props.questions.filter(q => q.correct_answer == '');
      if (this.props.client == 'WM') {
        for (let i = 0; i < questions.length; i++) {
          temp = i;
          leftPartOfQuestions.push(questions[i]);
        }
      } else {
        for (let i = 0; i < questions.length / 2; i++) {
          temp = i;
          leftPartOfQuestions.push(questions[i]);
          if(questions[i].tiebreaker_question) this.setState({ tiebreaker_id: questions[i]._id })
          if(questions[i].correct_answer != "") correct_answer_submitted += 1;
        }

        for (let j = temp + 1; j < questions.length; j++) {
          rightPartOfQuestions.push(questions[j]);
          if(questions[j].tiebreaker_question) this.setState({ tiebreaker_id: questions[j]._id })
          if(questions[j].correct_answer != "") correct_answer_submitted += 1;
        }
      }

      this.setState({
        tempIndex: temp + 1,
        leftPartOfQuestions: leftPartOfQuestions,
        rightPartOfQuestions: rightPartOfQuestions,
        correct_answer_submitted: correct_answer_submitted,
        open_questions: questions,
      });
    }
  }

  componentWillReceiveProps(nextProps) {}

  checkTieBreakerAdnBuildAnswers = (
    selected,
    answers,
    answered_tiebreaker_question,
  ) => {
    answers.map(ans => {
      if (ans.is_tiebreaker) {
        answered_tiebreaker_question = true;
        this.setState({ tiebreaker: ans })
      }

      selected[ans.question_id] = {
        _id: ans._id,
        answer: ans.answer,
      };
    });
    return {
      selected: selected,
      answered_tiebreaker_question: answered_tiebreaker_question,
    };
  };

  buildDataForBackend = (question, answer, is_tiebreaker) => {
    let data = {
      event_id: this.props.event._id,
      guest_id: this.props.guest._id,

      question_id: question._id,
      game_id: question.game_id,
      quarter_id: question.quarter_id,

      answer: answer,
      is_tiebreaker: is_tiebreaker,
    };
    return data;
  };

  //this on submit is for WM
  onSubmit = () => {
    //Here number of questions are excluding tiebreaker question
    if (this.state.question_count != this.state.questions_answered) {
      this.props.handleSanckbar('Please answer all the questions');
      return;
    }
    this.props.onSubmit(this.state.correct_answer_count);
  };

  //submittingIndividualChapter and sending response email to the guest
  submittingIndividualChapter = () => {
    let question_answer_count = this.state.question_answer_count;
    let tiebreaker_point = this.state.answered_tiebreaker_question ? 1 : 0;
    //checking if current chapter is active
    //if it is active the checking number of questions for this chapter minus number of tiebreaker questions of this chapter
    //doing subtraction because tiebreakers are optional
    // equal to answered questions of this chapter minus answered question of this chapter
    // currently there is just 1 tiebreaker question
    const mc_count = this.state.open_questions.length - question_answer_count.current_chapter_data.number_of_tiebreaker_questions;
    if (this.props.chapter.active) {
      if (
        mc_count == Object.keys(this.state.selected).length - tiebreaker_point ||
        mc_count == Object.keys(this.state.selected).length + this.state.correct_answer_submitted - tiebreaker_point
      ) {
        // Save tiebreaker answer when submitting the chapter if it was edited
        let { tiebreaker, selected, editedTiebreaker } = this.state;
        if(editedTiebreaker){
          let data = this.buildDataForBackend(tiebreaker, tiebreaker.answer, true);
          if(selected[tiebreaker._id] && selected[tiebreaker._id]._id){
            data['id'] = selected[tiebreaker._id]._id;
          }
          this.saveAnswer(data, true);
        }
        // Then submit
        this.props.onSubmit();
      } else {
        alert('answer all the questions');
      }
    }
  };

  //submittingEntireSeries and sending response email to the guest
  submittingEntireSeries = () => {
    let tiebreaker_point = this.state.answered_tiebreaker_question ? 1 : 0;
    if (this.props.chapter.active) {
      if (
        this.state.question_answer_count.total_questions -
          this.state.question_answer_count.total_tiebreaker_questions ==
        this.state.question_answer_count.total_answered_questions -
          this.state.question_answer_count.total_answered_tiebreaker_questions +
          (Object.keys(this.state.selected).length - tiebreaker_point)
      ) {
        this.props.onSubmit();
      } else {
        this.props.handleSanckbar('Please answer all the questions');
        return;
      }
    }
  };

  onAutoSelect = () => {
    let data = {
      guest_id: this.props.guest._id,
      event_id: this.props.event._id,
      quarter_id: this.props.current_chapter,
      game_id: this.props.game._id,
      last_quarter: false,
    };

    randomizePickemAnswer(data, response => {
      let selected = this.state.selected;
      if (response.randomizePickemAnswer.code == 200) {
        let answered_tiebreaker_question = this.state
          .answered_tiebreaker_question;

        let check = this.checkTieBreakerAdnBuildAnswers(
          selected,
          response.randomizePickemAnswer.data,
          answered_tiebreaker_question,
        );
        answered_tiebreaker_question = check.answered_tiebreaker_question;
        selected = check.selected;

        const max = this.state.open_questions.length;
        const current_question = this.state.current_question;

        this.setState({
          selected,
          answered_tiebreaker_question: answered_tiebreaker_question,
          current_question: max - 1,
        });
      }
    });
  };

  /**
   *
   * @param {Object} data
   * Saving data to the backend by calling savePickemAnswer mutation
   */
  saveAnswer = (data, flag_for_answered_tiebreaker_question) => {
    savePickemAnswer(data, response => {
      let selected = this.state.selected;
      selected[data.question_id] = {
        answer: data.answer,
        _id: response.savePickemAnswer.data._id,
      };

      this.setState({
        isOptionSubmitted: false,
        selected,
        correct_answer_count:
          this.state.correct_answer_count +
          response.savePickemAnswer.data.correct_answer_count,
        questions_answered: response.savePickemAnswer.data.questions_answered,
        answered_tiebreaker_question: this.state.answered_tiebreaker_question
          ? true
          : flag_for_answered_tiebreaker_question,
      });
    });
  };

  /**
   *
   * @param {Obect} question
   * @param {Object} option
   * This function get's called when option is selected or deselcted
   */
  onSelect(question, option) {
    this.setState({
      isOptionSubmitted: true,
    });

    let selected = this.state.selected;

    //preparing data to send it to the backend
    let data = this.buildDataForBackend(question, option._id, false);

    //if answer is already selected then update the
    //record by passing primary key (id) of answer in the data object
    if (selected[question._id] && selected[question._id]._id) {
      data['id'] = selected[question._id]._id;
    }

    //calling saveAnswer function to create or update the answer
    this.saveAnswer(data, false);
  }

  /**
   *
   * @param {Object} question
   * @param {Object} e
   * This function gets called when input for tiebreaker changes
   */
  onChangeTieBreakerQuestion(question, e) {
    let { selected, tiebreaker_id } = this.state;
    const id = question._id;
    if(selected[id]) selected[id]['answer'] = e.target.value;
    else {
      selected[tiebreaker_id] = {
        'answer': e.target.value,
      }
      if(e.target.value && e.target.value != '') this.setState({ answered_tiebreaker_question: true });
    }
    let tiebreaker = {
      ...question,
      answer: e.target.value,
    }
    this.setState({
      selected: selected,
      tiebreaker: tiebreaker,
      editedTiebreaker: true,
    });
  }

  submitChapter(chapter_num){
    // Save tiebreaker answer when submitting the chapter if it was edited
    let { tiebreaker, selected, editedTiebreaker } = this.state;
    if(editedTiebreaker){
      let data = this.buildDataForBackend(tiebreaker, tiebreaker.answer, true);
      if(selected[tiebreaker._id] && selected[tiebreaker._id]._id){
        data['id'] = selected[tiebreaker._id]._id;
      }
      this.saveAnswer(data, true);
      this.setState({ editedTiebreaker: false });
    }
    // Go to correct chapter
    this.props.setChapter(chapter_num);
  }

  mightyView(index, question, mobile) {
    const { classes, mightyMeals } = this.props;
    const correct_answer_submitted = question.correct_answer && question.correct_answer.length > 0;
    const highlightStyle = { border: '1px solid #182C55', backgroundColor: '#182C55', color: 'white' };
    const optionStyle = { border: '1px solid #182C55', backgroundColor: 'transparent', color: '#182C55' };

    return (
      <Grid item key={`Pickem-Question-${index}`} className={classes.pickemItem} style={{width: '100%'}}>
        <div className={classes.mightyIndex} style={{backgroundImage: `url('${MIGHTYMEALS_INDEX_IMG}')`, backgroundPosition: 'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}}>
          <p>{index}.</p>
        </div>
        <div className={classes.mightyQuestion}>
        <Typography
          variant="h2"
          key={`Question-Pickem${index}`}
          style={correct_answer_submitted ? { ...this.props.textStyle, textDecoration: 'line-through' } : this.props.textStyle}
        >
          {question.question}
        </Typography>
        {
          correct_answer_submitted &&
          <p className={classes.submittedText}>
            { mobile ? 'RESULT IS IN. GO TO NEXT QUESTION.' : 'RESULT IS IN.'}
          </p>
        }
        <div className={classes.pickemOptions}>
          {question.options &&
            question.options.map((option, i) => {
              return (
                <Button
                  key={`Button-Option-${i}`}
                  type="button"
                  disabled={correct_answer_submitted}
                  onClick={
                    //Calling OnSelect function to save option
                    this.onSelect.bind(this, question, option)
                  }
                  className={this.state.selected &&
                    this.state.selected[question._id] &&
                    this.state.selected[question._id].answer == option._id ?
                    classes.mightyButton :
                    classes.mightyBorderButton
                  }
                  style={
                    correct_answer_submitted ? {} :
                    this.state.selected &&
                    this.state.selected[question._id] &&
                    this.state.selected[question._id].answer == option._id
                      ? highlightStyle
                      : optionStyle
                  }
                >
                  {option.option}
                </Button>
              );
            })}
        </div>
        {question.tiebreaker_question &&
          (question.show_tiebreaker_question ||
            question.bonus_point_question) && (
            <TextField
              variant="outlined"
              key={`TextField-Pickem${index}`}
              disabled={this.props.disableOptions}
              value={
                this.state.selected &&
                this.state.selected[question._id] &&
                this.state.selected[question._id].answer
              }
              className={classes.tieBreaker}
              onChange={this.onChangeTieBreakerQuestion.bind(this, question)}
            />
          )}
        </div>
      </Grid>
    )
  }

  questionView(index, question) {
    const correct_answer_submitted = question && question.correct_answer && question.correct_answer.length > 0;
    const { classes, mightyMeals, optionStyle } = this.props;
    const uhg = this.props.event && this.props.event.client && this.props.event.client.client_name.includes('UHG');
    if(!correct_answer_submitted && question) return (
      <Grid
        key={`Pickem-Question-${index}`}
        item
        className={clsx(classes.pickemItem, this.props.pickemContainer)}
      >
        <Typography
          variant="h2"
          key={`Question-Pickem${index}`}
          style={correct_answer_submitted ? { ...this.props.textStyle, textDecoration: 'line-through' } : this.props.textStyle}
        >
          {question.question && question.tiebreaker_question
            ? `Tiebreaker Question -  ${' '}
            ${question.question}`
            : question.question &&
              `${index}. ${' '}
           ${question.question}`}
        </Typography>
        {
          correct_answer_submitted &&
          <p className={classes.submittedText} style={{ color: optionStyle.borderColor }}>
            RESULT IS IN.
          </p>
        }
        <div className={classes.pickemOptions}>
          {question.options &&
            question.options.map((option, i) => {
              return (
                <Button
                  key={`Button-Option-${i}`}
                  color="secondary"
                  size="large"
                  type="button"
                  variant="contained"
                  disabled={
                    //Disabling the option by checking props
                    this.state.isOptionSubmitted || this.props.disableOptions || correct_answer_submitted
                  }
                  onClick={
                    //Calling OnSelect function to save option
                    this.onSelect.bind(this, question, option)
                  }
                  style={
                    correct_answer_submitted ? {} :
                    this.state.selected &&
                    this.state.selected[question._id] &&
                    this.state.selected[question._id].answer == option._id
                      ? this.props.highlightStyle
                      : this.props.optionStyle
                  }
                  className={clsx(
                    classes.submitButton,
                    mightyMeals ? classes.mightyButton : classes.borderButton,
                    this.props.optnStyle,
                  )}
                >
                  {option.option}
                </Button>
              );
            })}
        </div>
        {question.tiebreaker_question &&
          (question.show_tiebreaker_question ||
            question.bonus_point_question) && (
            <TextField
              variant="outlined"
              key={`TextField-Pickem${index}`}
              disabled={this.props.disableOptions}
              value={
                this.state.selected &&
                this.state.selected[question._id] &&
                this.state.selected[question._id].answer
              }
              className={uhg ? classes.tieBreakerUHG : classes.tieBreaker}
              onChange={this.onChangeTieBreakerQuestion.bind(this, question)}
            />
          )}
      </Grid>
    );
  }

  getView(classes, mightyMeals) {
    let viewJSX = [];
    let temp = this.state.tempIndex;
    const optionStyle = this.props.optionStyle;
    const borderColor = optionStyle && optionStyle.borderColor ? optionStyle.borderColor : '#182C55';

    viewJSX.push(
      <>
        <Grid
          conatiner
          className={
            this.state.rightPartOfQuestions.length > 0
              ? classes.pickemItemHalfContainer
              : classes.pickemItemFullContainer
          }
        >
          {this.state.leftPartOfQuestions.map((question, index) => {
            if (mightyMeals) return <Grid container key={`mighty-${index}`}>{this.mightyView(index + 1, question)}</Grid>;
            else return this.questionView(index + 1, question);
          })}
        </Grid>

        {this.state.rightPartOfQuestions.length > 0 && (
          <Grid container className={classes.pickemItemHalfContainer}>
            {this.state.rightPartOfQuestions.map((quest, questIndex) => {
              temp += 1;

              if (mightyMeals) return this.mightyView(temp, quest);
              else return this.questionView(temp, quest);
            })}
            <div className={classes.submitView}>
            <GeneralSubmitView
              {...this.props}
              submittingEntireSeries={this.submittingEntireSeries}
              submittingIndividualChapter={this.submittingIndividualChapter}
              submitChapter={this.submitChapter}
              submitButtonStyle={{
                backgroundColor: mightyMeals ? 'black' : borderColor,
                border: mightyMeals ? '1px solid black' : `1px solid ${borderColor}`,
                color: 'white',
                fontFamily: mightyMeals ? '"Barlow", sans-serif' : '',
              }}
            />
            </div>
          </Grid>
        )}
      </>,
    );

    return viewJSX;
  }

  changeQuestion(n){
    const questions = this.state.open_questions;
    const max = questions.length;
    const current = this.state.current_question;
    if(current + n < max && current + n >= 0) this.setState({ current_question: current + n });
  }

  getMobileView(classes, mobile_landscape){
    const questions = this.state.open_questions;
    const i = this.state.current_question;
    const max = questions.length;
    const progress = ((i + 1) / max) * 100;
    const btnColor = this.props.optionStyle.borderColor;
    return (
      <Grid container style={mobile_landscape ? { marginBottom: '5em'} : {}}>
        {this.questionView(i + 1, questions[i])}
        {
        mobile_landscape &&
        <Grid item xs={8} style={{ paddingLeft: '1em', marginTop: '1em', marginBottom: '3em' }}>
          <div className={classes.progressTotal} style={{ backgroundColor: '#D9D9D9', width: '100%', borderRadius: '4px' }}>
            <div className={classes.progressBar} style={{ backgroundColor: btnColor, width: `${progress}%`, color: 'white', fontSize: '0.8em', padding: '2px', textAlign: 'center', borderRadius: '4px' }}>
              {i + 1} of {max}
            </div>
          </div>
        </Grid>
        }
        {
          i + 1 == max ?
          <Grid item xs={mobile_landscape ? 4 : 12}>
            <GeneralSubmitView
              {...this.props}
              classes={{
                actionButton: {
                  width: mobile_landscape ? '30%' : '20%',
                  height: '40px',
                  borderRadius: '4px',
                  border: `1px solid ${btnColor}`,
                  color: 'white',
                  backgroundColor: btnColor,
                  cursor: 'pointer',
                  margin: '10px 0px 10px 10px',
                  float: 'right',
                  textTransform: 'none',
                }
              }}
              submittingEntireSeries={this.submittingEntireSeries}
              submittingIndividualChapter={this.submittingIndividualChapter}
              submitChapter={this.submitChapter}
              submitButtonStyle={{
                width: mobile_landscape ? '30%' : '20%',
                height: '40px',
                borderRadius: '4px',
                border: `1px solid ${btnColor}`,
                color: 'white',
                backgroundColor: btnColor,
                cursor: 'pointer',
                margin: '10px 0px 10px 10px',
                float: 'right',
                textTransform: 'none',
              }}
              mobile={true}
            />
            <button
              className={classes.prevButton}
              onClick={() => this.changeQuestion(-1)}
              style={mobile_landscape ? { width: '30%', border: `1px solid ${btnColor}`, color: btnColor } : { border: `1px solid ${btnColor}`, color: btnColor }}
            >
              Previous
            </button>
          </Grid>
          :
          <Grid item xs={mobile_landscape ? 4 : 12}>
            <button
              className={classes.nextButton}
              onClick={() => this.changeQuestion(1)}
              style={mobile_landscape ? { width: '30%', border: `1px solid ${btnColor}`, backgroundColor: btnColor, color: 'white' } : { border: `1px solid ${btnColor}`, backgroundColor: btnColor, color: 'white' }}
            >
              Next
            </button>
            {i != 0 ?
            <button
              className={classes.prevButton}
              onClick={() => this.changeQuestion(-1)}
              style={mobile_landscape ? { width: '30%', border: `1px solid ${btnColor}`, color: btnColor, backgroundColor: 'white' } : { border: `1px solid ${btnColor}`, color: btnColor, backgroundColor: 'white' }}
            >
              Previous
            </button> : <></>}
          </Grid>
        }
        {
        !mobile_landscape &&
        <Grid item xs={12} style={{ marginTop: '1em', marginBottom: '3em' }}>
          <div className={classes.progressTotal} style={{ backgroundColor: '#D9D9D9', width: '100%', borderRadius: '4px' }}>
            <div className={classes.progressBar} style={{ backgroundColor: btnColor, width: `${progress}%`, color: 'white', fontSize: '0.8em', padding: '2px', textAlign: 'center', borderRadius: '4px' }}>
              {i + 1} of {max}
            </div>
          </div>
        </Grid>
        }
      </Grid>
    )
  }

  render() {
    const { classes, mightyMeals, mobile, mobile_landscape } = this.props;

    return (
      <Grid container style={this.props.pickemRoot}>
        {/**This block shows auto select button which randomizes the guest answers
         * Show Auto select for client other than waste management
         */}
        {!this.props.client && !mightyMeals && (
          <Button
            className={clsx(classes.submitButton, classes.actionButton)}
            style={{
              marginTop: '20px',
              ...this.props.optionStyle,
            }}
            disabled={!this.props.chapter.active}
            onClick={this.props.chapter.active ? this.onAutoSelect : ''}
          >
            { mobile || mobile_landscape ? 'Auto Select All Questions' : 'Auto Select' }
          </Button>
        )}

        <Grid container className={classes.pickemMainContainer} style={ mightyMeals ? { marginBottom: '10%' } : {}}>
          {
            mobile || mobile_landscape ?
            this.getMobileView(classes, mobile_landscape) :
            this.getView(classes, mightyMeals)
          }
        </Grid>

        {/**following block gets button view */}
        {/*this.props.client == 'WM' ? (
          <WMSubmit {...this.props} onSubmit={this.onSubmit} />
        ) : (
          <>
            <br />
            <GeneralSubmitView
              {...this.props}
              submittingEntireSeries={this.submittingEntireSeries}
              submittingIndividualChapter={this.submittingIndividualChapter}
              submitChapter={this.submitChapter}
            />
          </>
        )*/}
      </Grid>
    );
  }
}

Pickem.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Pickem);
